import { FormControl, UntypedFormGroup } from "@angular/forms";
import { HttpClient } from "@angular/common/http";
import LayerUtils from "@vision/core-map-api/src/utils/LayerUtils";
import { Inject } from "@angular/core";
import { MatDialog, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { IDialogData } from "../../viewer-components/interfaces/i-dialog-data";
import { GeoJSONDatabaseService } from "../../viewer-components/services/internal-services/geojson-database.service";
import { ViewerConfigurationService } from "../../viewer-components/services/viewer-configuration.service";
import { Viewerlayer } from "../../viewer-components/model/viewerlayer";
import { ViewerConstants } from "../../shared/model/viewer-constants";
import { GoogleAnalyticsService } from "../../shared/services/google-analytics.service";

export abstract class VectorTileLayerResultsDialogComponent {
  isAuthRequired: boolean = false;

  hide = true;

  urlTiles: string = null;

  urlStyles: string = null;

  maxZoom: number;

  minZoom: number;

  layers: any[];

  isArcGISAuth: boolean = false;

  url: string;

  token: string;

  error: boolean = false;

  username: string = "";

  password: string = "";

  formatPercentLabel = (value: number) => `${value}%`;

  newLayerForm = new UntypedFormGroup({
    newVectorTileLayerName: new FormControl(""),
    newVectorTileLayerOpacity: new FormControl(100),
  });

  protected constructor(
    protected http: HttpClient,
    protected viewerConfigurationService: ViewerConfigurationService,
    protected geoJSONDatabaseService: GeoJSONDatabaseService,
    protected googleAnalyticsService: GoogleAnalyticsService,
    protected matDialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: IDialogData,
  ) {
    this.url = data.url;
    this.username = data.username;
    this.password = data.password;
    this.isAuthRequired = data.isAuthRequired;
    this.isArcGISAuth = data.isArcGISAuth;
    this.urlTiles = data.urlTiles;
    this.urlStyles = data.urlStyles;
    this.maxZoom = data.maxZoom;
    this.minZoom = data.minZoom;
  }

  changeCheckLayer(checked: boolean, layer: any) {
    layer.checked = checked;
  }

  anyChecked(): boolean {
    return this.urlTiles !== null;
  }

  addVectorTileLayers() {
    const url = this.urlTiles;

    let extraParams;
    const layerNames = [];

    if (this.username.length > 0 && this.password.length > 0) {
      extraParams = {
        URL_ORIGIN: url,
        USERNAME: this.username,
        PASSWORD: this.password,
        TOKEN: this.token,
      };
    }
    let config;
    if (this.urlStyles) {
      config = {
        styleUrl: this.urlStyles,
      };
    }
    const vectorTileStyle = "";
    const layersText = layerNames.join(",");
    let name = this.newLayerForm.get("newVectorTileLayerName").value;
    let opacity = this.newLayerForm.get("newVectorTileLayerOpacity").value;
    if (name.length === 0) {
      name = "Custom VectorTile Layer";
    }
    if (opacity === "") {
      opacity = 1;
    } else {
      opacity /= 100;
    }

    const layer = {
      source: ViewerConstants.SOURCE_NAME.VECTORTILES,
      url,
      extraParams,
      removable: true,
      editable: false,
      owner: true,
      layer: layersText,
      isBase: false,
      opacity,
      visible: true,
      maxZoom: this.maxZoom,
      minZoom: this.minZoom,
      realId: `${name.replace(/ /g, "")}_${LayerUtils.layerGuid()}`,
      id: `${name}_${LayerUtils.layerGuid()}`,
      name,
      panelInclude: true,
      style: vectorTileStyle,
      config,
      order: ViewerConstants.USER_LAYER_BASE_ZINDEX,
      userId: this.viewerConfigurationService.getViewerConfiguration().userId,
    };

    const layerToSave = LayerUtils.processLayer(layer) as unknown as Viewerlayer;
    this.saveLayer(layerToSave);

    this.matDialog.closeAll();
  }

  abstract saveLayer(layer: Viewerlayer);
}
